'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
require('./Modal.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * ModalBackdrop view component, does not manage its own state.
 */
var ModalBackdrop = function ModalBackdrop(_ref) {
  var _ref$visible = _ref.visible,
    visible = _ref$visible === undefined ? false : _ref$visible;
  var backdropClass = (0, _classnames2.default)('c-modal-backdrop', {
    'c-modal-backdrop--visible': visible
  });
  return _react2.default.createElement('div', {
    className: backdropClass
  });
};
ModalBackdrop.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Whether or not to show the backdrop */
  visible: _propTypes2.default.bool
} : {};
exports.default = ModalBackdrop;